import { render, staticRenderFns } from "./UsuarioInstitucionalForm.vue?vue&type=template&id=2f977ad0"
import script from "./UsuarioInstitucionalForm.vue?vue&type=script&lang=js"
export * from "./UsuarioInstitucionalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports